import { useParams } from "react-router-dom";
import DatasetCollaborators from "datasets/types/interfaces/collaborators";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const useCollaborators = () => {
  const { datasetId } = useParams();
  return useFetcher<DatasetCollaborators>(
    datasetId ? `${VITE_CATALOG_API}/datasets/${datasetId}/users` : null,
    { revalidateOnFocus: false, errorRetryCount: 0, errorRetryInterval: 0 }
  );
};

export default useCollaborators;
